import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

export const DeleteUserModal = (props) => {
  const {
    message,
    title,
    onConfirm,
    onExit,
    setShowDeleteUser,
    showDeleteUser,
  } = props;
  return (
    <Modal
      opened={showDeleteUser}
      disableOutsideClick={true}
      ariaLabel={`${title} Modal`}
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      onClose={setShowDeleteUser}
      width={"800px"}
      closeButton={
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
          }}
          onClick={onExit}
        >
          <Icon name="close" />
        </div>
      }
    >
      <ModalTitle>
        <Title size="large"><span style={{ fontWeight: 700, fontSize: 32 }}>{title}</span></Title>
      </ModalTitle>
      <ModalBody>
        <Body size="large">
          {message || "Are you sure you want to delete the Rule"}
        </Body>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            width: "100%",
            children: "Yes, delete",  // Changed to 'Yes, delete'
            onClick: onConfirm,       // Changed to 'onConfirm'
          },
          primary: {
            width: "100%",
            children: "No, cancel",  // Changed to 'No, cancel'
            onClick: onExit,          // Changed to 'onExit'
          },
        }}
      />

    </Modal>
  );
};
